<template>
  <v-chip v-bind="buttonBind" v-text="title" @click="onClick" :class="classes.join(' ')" />
</template>
<script>
export default {
  name: 'ButtonActivable',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    activeTextColor: {
      type: String,
      default: 'primary',
    },
    activeBackgroundColor: {
      type: String,
      default: 'primarybackground',
    },
    inactiveTextColor: {
      type: String,
      default: 'rgba(0,0,0,0.6)',
    },
    inactiveBackgroundColor: {
      type: String,
      default: 'rgba(152,152,152,0.12)',
    },
    classes: {
      type: Array,
      default: () => {
        return ['font-weight-medium'];
      },
    },
    titlePath: {
      type: String,
      default: '',
    },
    titleStraight: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    buttonBind() {
      return { color: this.currentBackgroundColor, textColor: this.currentTextColor, ...this.$attrs, ...this.$props };
    },
    currentTextColor() {
      return this.computedValue ? this.activeTextColor : this.inactiveTextColor;
    },
    currentBackgroundColor() {
      return this.computedValue ? this.activeBackgroundColor : this.inactiveBackgroundColor;
    },
    title() {
      return this.titleStraight || this.$i18n.t(this.titlePath) || '';
    },
  },
  methods: {
    onClick() {
      this.computedValue = !this.computedValue;
      this.$emit('click');
    },
  },
};
</script>
